<h1 mat-dialog-title>{{'Create user' | translate}}</h1>
<div mat-dialog-content>
    <!-- <p>
        {{'Do you want confirm?' | translate}}
    </p> -->
    <form [formGroup]="form">
        <mat-form-field class="example-full-width">
            <mat-label>{{'Name' | translate}}</mat-label>
            <input matInput placeholder="{{'Name' | translate}}" type="text" required [formControl]="name">
            <mat-error *ngIf="name.hasError('required')">
                {{'Required' | translate}}
            </mat-error>
        </mat-form-field>
        <mat-form-field class="example-full-width">
            <mat-label>{{'Email' | translate}}</mat-label>
            <input matInput placeholder="{{'Email' | translate}}" type="email" required [formControl]="email">
            <mat-error *ngIf="email.hasError('required')">
                {{'Required' | translate}}
            </mat-error>
        </mat-form-field>
        <mat-form-field class="example-full-width">
            <mat-label>{{'Password' | translate}}</mat-label>
            <input matInput placeholder="{{'Password' | translate}}" type="password" [formControl]="password">
            <mat-error *ngIf="password.hasError('required')">
                {{'Required' | translate}}
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>{{'Role' | translate}}</mat-label>
            <mat-select [formControl]="role">
                <mat-option [value]="USER_ROLES.user">
                    {{'User' | translate}}
                </mat-option>
                <mat-option [value]="USER_ROLES.admin">
                    {{'Admin' | translate}}
                </mat-option>
                <mat-option [value]="USER_ROLES.root">
                    {{'Root' | translate}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="role.hasError('required')">
                {{'Required' | translate}}
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>{{'Plan' | translate}}</mat-label>
            <mat-select [formControl]="plan">
                <mat-option [value]="ACCOUNT_VERSION.standart">
                    {{'Standart' | translate}}
                </mat-option>
                <mat-option [value]="ACCOUNT_VERSION.pro">
                    {{'Pro' | translate}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="role.hasError('required')">
                {{'Required' | translate}}
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>{{'Cluster Id' | translate}}</mat-label>
            <mat-select [formControl]="clusterId">
                <mat-option [value]="''">
                    {{'Any' | translate}}
                </mat-option>
                <mat-option *ngFor="let cluster of clustersList" [value]="cluster.cluster_id || null">
                    {{cluster.cluster_name}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="role.hasError('required')">
                {{'Required' | translate}}
            </mat-error>
        </mat-form-field>
    </form>

</div>
<div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="confirm()" [disabled]="form.invalid">
        <ng-container *ngIf="!data">
            {{'Create' | translate}}
        </ng-container>
        <ng-container *ngIf="data">
            {{'Edit' | translate}}
        </ng-container>
    </button>
    <button mat-raised-button color="primary" (click)="cancel()">{{'Cancel' | translate}}</button>
</div>